import { marked } from 'marked'
import markedCjkFriendly from 'marked-cjk-friendly'

// Every importer of this module shares one `marked` singleton that already has
// CJK-friendly emphasis registered, whichever module happens to evaluate first.
marked.use(markedCjkFriendly())

export { marked }
